import { Component, Input } from "@angular/core"
import { NotificationsService } from "angular2-notifications"
import { UserService } from "../../../services/user.service"
import Utils from "../../../utils/utils"
import { ModalRef } from "../../modal/modal-ref"
import { JoinedRoster } from "../../../models/student-site/joined-roster.model"
import { Router } from "@angular/router"

@Component({
    selector: "app-leave-roster-modal",
    templateUrl: "./leave-roster-modal.component.html",
    styleUrls: ["./leave-roster-modal.component.scss"],
})
export class LeaveRosterModalComponent {
    @Input() public classDetails = ""
    @Input() public roster: JoinedRoster = null

    constructor(
        public activeModal: ModalRef,
        private userService: UserService,
        private notificationService: NotificationsService,
        private router: Router
    ) {}

    public leaveClass() {
        if (!this.roster.leaveRosterURL) {
            this.notificationService.error(
                "Uh oh!",
                "Something went wrong. Try this in a couple of minutes.",
                Utils.alertConfiguration
            )
            return
        }
        this.userService.leaveClass(this.roster).subscribe(
            (response) => {
                this.router.navigate([])
            },
            (error) => {
                this.notificationService.error(
                    "Uh oh!",
                    "Could remove you from the class.",
                    Utils.alertConfiguration
                )
            }
        )
    }
}
